module.exports = __webpack_public_path__ + "static/img/bg.dca4c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 0